import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-general-21v3',
  templateUrl: './21v3.component.html',
})
export class VbGeneral21v3Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
